import { type CookieData } from '~/composables/useCookieData';

export function prepareCookieHeaders(
	cookies?: CookieData
): Record<string, string> {
	if (!cookies) return {};

	const cookie = Object.entries(cookies)
		.filter(([, v]) => v)
		.map(([k, v]) => `${k}=${encodeURIComponent(v!)}`)
		.join('; ');

	return cookie ? { cookie } : {};
}
